var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#494c4e",
    d: "M19 5.85c0-.9-.44-1.71-1.16-2.22-.1-1.31-1.16-2.36-2.47-2.47C14.89.45 14.08.02 13.15 0c-.06 0-.21 0-.36.03-.28.04-.54.12-.79.23-.55-.26-1.11-.33-1.81-.18-.65.17-1.18.56-1.55 1.08-.63.05-1.21.32-1.69.77-.45.46-.72 1.08-.78 1.7-.53.37-.91.9-1.09 1.53-.148.61-.078 1.27.182 1.84-.26.56-.34 1.22-.18 1.83.18.63.56 1.17 1.08 1.54.06.62.33 1.23.78 1.69.32.3.67.52 1.06.65v9.91c0 .33.12.66.35.92.44.5 1.26.61 1.82.21l1.83-1.66 1.72 1.57c.26.22.57.34.9.34.4 0 .77-.17 1.04-.47.22-.25.34-.58.34-.91v-9.91c.38-.13.74-.35 1.05-.64.45-.46.73-1.08.79-1.7.51-.37.9-.91 1.07-1.53.148-.61.088-1.27-.172-1.84.17-.36.26-.75.26-1.15zm-5 15.36l-2-1.82-2 1.82v-7.36c.05.03.11.04.17.06.72.17 1.27.09 1.83-.17.35.17.75.26 1.15.26.22 0 .42-.03.66-.08.07-.02.13-.04.19-.07v7.36zm2.94-12.9c-.12.45-.4.83-.77 1.1-.04.44-.24.88-.56 1.21-.34.32-.76.52-1.2.55-.26.37-.66.64-1.12.77-.17.04-.31.06-.47.06-.28 0-.57-.06-.82-.19-.4.19-.79.25-1.31.13-.45-.13-.84-.4-1.1-.77-.44-.03-.86-.23-1.21-.56-.32-.33-.51-.76-.55-1.2-.37-.27-.65-.65-.77-1.1-.108-.44-.058-.91.122-1.31-.18-.41-.23-.88-.12-1.32.12-.44.4-.83.78-1.09.04-.44.23-.88.55-1.21.35-.33.76-.52 1.21-.55.26-.38.65-.65 1.11-.77.5-.11.9-.06 1.29.13.18-.08.36-.14.56-.17.11-.02.22-.02.26-.02.66.02 1.24.32 1.59.83.94.08 1.69.82 1.76 1.76.508.36.828.95.828 1.59 0 .28-.06.57-.18.82.18.41.23.88.12 1.31z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#494c4e",
    cx: 12.001,
    cy: 7,
    r: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrade);
export default __webpack_public_path__ + "static/media/grade.02e32a87d5af81a519c2a1a167dcdeb9.svg";
export { ForwardRef as ReactComponent };